import React from 'react'
import { formTypeList } from '../../constants/form'
import StoreCreditForm from './StoreCreditForm'

const AddNewStoreCredit = ({ setOpen, customerId }) => {
    return (
        <StoreCreditForm
            formType={formTypeList.NEW}
            setOpen={setOpen}
            customerId={customerId}
        />
    )
}

export default AddNewStoreCredit
